export const arrayHead = (array) => (array?.length > 0 ? array[0] : null);
